// ============================================================
// Datei: src/pages/ressorts/sarasani/SarasaniDesktop.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName + filterFn
// - Aufbau / Abbau bleiben sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";

import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";
import VolunteerPool from "../../../components/VolunteerPool";

import "./sarasani.css";

const SarasaniDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers
}) => {
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	const sarasaniAufbau = shifts.filter((s) => s.shiftId >= 611 && s.shiftId <= 617);
	const sarasaniAbbau = shifts.filter((s) => s.shiftId >= 631 && s.shiftId <= 636);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" + (activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Sarasani"
									onAssigned={() => {
										if (reloadVolunteers) reloadVolunteers();
									}}
								/>
							</div>
						</div>
					)}

					{activeTab === "shifts" && (
						<>
							<h3 className="sarasani-subheading">Aufbau</h3>
							<ShiftTable
								shifts={sarasaniAufbau}
								departmentName="Sarasani"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 611 && shift.shiftId <= 617}
							/>

							<h3 className="sarasani-subheading">Abbau</h3>
							<ShiftTable
								shifts={sarasaniAbbau}
								departmentName="Sarasani"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 631 && shift.shiftId <= 636}
							/>
						</>
					)}

					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={setGuestToEdit}
								onDelete={setGuestToDelete}
							/>
						</>
					)}
				</div>
			</div>

			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={reloadVolunteers}
				/>
			)}

			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default SarasaniDesktop;